(function () {
  var TAPE_VARIANT_ID = 56939071537500;
  var BRUSH_VARIANT_ID = 57019220820316;
  var CLEANSER_VARIANT_ID = 58624582844764;

  var GIFTS = [BRUSH_VARIANT_ID, CLEANSER_VARIANT_ID, TAPE_VARIANT_ID];

  function nonGiftQty(cart) {
    return cart.items.reduce(function (sum, i) {
      return GIFTS.indexOf(i.variant_id) === -1 ? sum + i.quantity : sum;
    }, 0);
  }

  function hasVariant(cart, id) {
    return cart.items.some(function (i) { return i.variant_id === id; });
  }

  function addToCart(variantId, propLabel, btn, container) {
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_gift': propLabel } }] })
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
      if (container) container.remove();
    });
  }

  function makeBanner(text, buttonText, onClick) {
    var el = document.createElement('div');
    el.setAttribute('data-gift-banner', '');
    el.style.cssText = 'margin:10px 0;padding:12px;border:1.5px dashed #8C6A3D;border-radius:10px;font-size:13px;';
    el.innerHTML = '<div>' + text + '</div><button type="button" style="margin-top:8px;padding:6px 14px;border-radius:20px;border:1px solid currentColor;background:transparent;cursor:pointer;font-size:12px;">' + buttonText + '</button>';
    el.querySelector('button').addEventListener('click', function (e) {
      e.preventDefault();
      onClick(e.target, el);
    });
    return el;
  }

  function render(container) {
    if (!container) return;
    container.querySelectorAll('[data-gift-banner]').forEach(function (n) { n.remove(); });

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count === 0) return;
      var qty = nonGiftQty(cart);
      var frag = document.createDocumentFragment();

      if (qty >= 5 && !hasVariant(cart, CLEANSER_VARIANT_ID)) {
        frag.appendChild(makeBanner(
          '<strong>Gratis Elleebana Make-up Remover 30ml</strong><br>Bij 5+ stuks — voeg toe, hij wordt automatisch gratis bij checkout.',
          'Voeg gratis cleanser toe',
          function (btn, el) { addToCart(CLEANSER_VARIANT_ID, '5+ stuks gift', btn, el); }
        ));
      } else if (qty >= 3 && !hasVariant(cart, BRUSH_VARIANT_ID)) {
        frag.appendChild(makeBanner(
          '<strong>Gratis Mascara Borsteltjes</strong><br>Bij 3+ stuks — voeg toe, hij wordt automatisch gratis bij checkout.',
          'Voeg gratis borsteltjes toe',
          function (btn, el) { addToCart(BRUSH_VARIANT_ID, '3+ stuks gift', btn, el); }
        ));
      }

      if (!hasVariant(cart, TAPE_VARIANT_ID)) {
        frag.appendChild(makeBanner(
          '<strong>Gratis Elleebana Tape</strong><br>Bij je eerste bestelling: voeg toe en vul code <strong>ELLEEBANAGIFT</strong> in bij afrekenen.',
          'Voeg gratis tape toe',
          function (btn, el) { addToCart(TAPE_VARIANT_ID, 'ELLEEBANAGIFT eerste bestelling', btn, el); }
        ));
      }

      container.prepend(frag);
    }).catch(function () {});
  }

  function init() {
    var drawerFooter = document.querySelector('.cart-drawer__footer [data-merge="footer"]');
    if (drawerFooter) render(drawerFooter);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:refresh', init);
  document.addEventListener('shopify:section:load', init);
})();
